import gql from 'graphql-tag';

export type ProgramBrowsingExperienceQueryResult = {
  ProgramBrowsingExperiencesV1?: {
    get?: {
      elements?: Array<{
        id: string;
        browsingExperience: 'DEEP_BROWSE' | 'SMALL_SUBSET';
        numCollections: number;
      }>;
    };
  };
};

export type ProgramBrowsingExperienceQueryVariables = {
  programId: string;
};

const ProgramBrowsingExperienceQuery = gql`
  query ProgramBrowsingExperience($programId: String!) {
    ProgramBrowsingExperiencesV1 @naptime {
      get(id: $programId) {
        elements {
          id
          browsingExperience
          numCollections
        }
      }
    }
  }
`;

export default ProgramBrowsingExperienceQuery;
